import { render, staticRenderFns } from "./GameList.vue?vue&type=template&id=51190f44&scoped=true"
import script from "./GameList.vue?vue&type=script&lang=js"
export * from "./GameList.vue?vue&type=script&lang=js"
import style0 from "./GameList.vue?vue&type=style&index=0&id=51190f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51190f44",
  null
  
)

export default component.exports